import React, { useEffect } from 'react';

const Support = () => {
//   useEffect(() => {
//     const script = document.createElement('script');
//     script.async = true;
//     script.src = 'https://embed.tawk.to/6698a538becc2fed6926f630/1i324aqnc';
//     script.charset = 'UTF-8';
//     script.setAttribute('crossorigin', '*');

//     document.body.appendChild(script);

//     return () => {
//       document.body.removeChild(script);
//     };
//   }, []);

  return (
    <div>
  
    </div>
  );
};

export default Support;
